import classnames from 'classnames';
import isNil from 'lodash/isNil';

import { Nullable } from 'chaika-frontend-types/frontend-cms';

import style from './DynamicTitle.module.scss';

export interface DynamicTitleProps {
    title: string;
    isOpen: boolean;
    boldTitle?: boolean;
    isValid?: Nullable<boolean>;
    disabled?: boolean;
    zIndex?: number;
    modifiers?: DynamicTitleModifiers[];
}

export enum DynamicTitleModifiers {
    // @ts-ignore
    BoldTitle = style.bold,
    // @ts-ignore
    WithoutPadding = style.withoutPadding,
}

export function DynamicTitle({
    title = '',
    isOpen,
    boldTitle,
    isValid,
    disabled,
    zIndex,
    modifiers = [],
}: DynamicTitleProps) {
    return (
        <div
            className={classnames([
                style.title,
                style.title_redesign,
                boldTitle && style.bold,
                isOpen && style.titleOnTop,
                !isNil(isValid) && (isValid ? style.valid : style.notValid),
                disabled && style.disabled,
                ...modifiers,
            ])}
            style={{
                zIndex,
            }}
        >
            {title}
        </div>
    );
}
